const { addPaymentButton } = require("./types/add-payment-btn");
const { clickableMenu } = require("./types/clickable-menu");
const { startGoogleMessage } = require("./types/google-maps");
const { initUserConsFunc } = require("./types/ip-gathering");
const { leadSource } = require("./types/lead-source");
const { checkOfferFilters } = require("./utils/check-offer-filters");
const { checkForTooltips } = require("./utils/check-tooltips");
const { highlightSelectedOffers } = require("./utils/highlight-selectOffer");
const { progressBarClassChange } = require("./utils/progress-bar-classes");
const { scrollToTop } = require("./utils/scroll-top");
const { sendEmailSuccessMessage } = require("./utils/send-email-success");
const { sendPaymentLink } = require("./utils/send-payment-link");

function handleRakProcessInit() {
    function processInitFunctions() {
        console.log("processInit functions triggered");
        clickableMenu();
        checkOfferFilters();
        progressBarClassChange();
        highlightSelectedOffers();
        checkForTooltips();
        setTimeout(() => {startGoogleMessage()}, 1000);
        initUserConsFunc();
        scrollToTop();
        leadSource();
        addPaymentButton();
        sendEmailSuccessMessage();
        sendPaymentLink();
    }

    document.addEventListener("processInitialised.skye", processInitFunctions, false);
}

handleRakProcessInit();